<template>
  <div class="card yellowtunnel rounded p-3 text-white side border-0">
    <recent-posts :recentPostsItems="recentPostsItems" />
    <archive :archiveItems="archiveItems" />
  </div>
</template>

<script>
import RecentPosts from "./RecentPosts.vue";
import Archive from "./Archive.vue";
export default {
  name: "SideMenu",
  props: {
    recentPostsItems: Array,
    archiveItems: Array,
  },
  components: {
    RecentPosts,
    Archive,
  },
};
</script>

<style lang="postcss">
.side {
  h2 {
    position: relative;
    margin-bottom: 15px;
    padding-bottom: 15px;
    font-size: 24px;
    font-weight: 500;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      bottom: -2px;
      width: 100%;
      height: 2px;
      background: #eee;
    }

    /* &:after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -2px;
        width: 35%;
        height: 2px;
        background: #542a78;
      } */
  }
}
</style>